<template>
    <div class="LoopMonitoring">
        <div class="title">回路监测</div>
            <div class="content">
                <div class="left">
                <div class="search">
                    <el-input
                        placeholder="输入回路名称以搜索"
                        suffix-icon="el-icon-search"
                        v-model="keyword">
                    </el-input>
                    <div class="all">回路列表 
                        <template v-if="homeitem.roleId=='-9999'">
                            <span class="edit" @click="editmodeFun" v-if="!editmode">编辑模式</span><span class="edit red" v-else @click="exitFun">退出编辑</span>
                            <span class="edit" style="margin-right:5px;width: 59px;" @click="insert()" v-if="currentLoop.loopType=='OUT'&&editmode">插入</span>
                        </template>
                    </div>
                </div>
                
                <!-- :draggable="draggable" -->
                <div class="mytree" :class="{'editmode':editmode}">
                    <el-tree 
                    ref="tree"
                    :data="list" 
                    :node-key="loopId"
                    default-expand-all 
                    :props="defaultProps" 
                    @node-click="handleNodeClick"
                    :filter-node-method="filterNode"
                    :expand-on-click-node="false">
                        <div class="custom-tree-node" slot-scope="{ node, data }" :class="{ 'checked': (data.loopId === currentLoop.loopId)&&currentLoop.loopId&&data.loopId,'row-center':!data.add,'isadd':data.add,'chh':node.childNodes.length>0 }">
                            <div class="land row-center">
                                <span class="name" :title="data.loopName" v-if="!data.edit" :id="data.loopId">{{ data.loopName }}</span>
                                <span v-else style="width:65%;"><el-input v-model="data.loopName" placeholder="请输入内容" style="width:100%;"></el-input></span>
                                <span class="handle" v-if="data.edit!=undefined&&editmode&&node.level!=1">
                                    <img src="@/assets/img/branch.png" alt=""  style="width:16px" title="添加下级" v-if="data.loopType!='OUT'&&data.loopType!='GTI'&&!data.edit" @click.stop="addChildren(data,node)">
                                    <!-- <img src="@/assets/img/add.png" alt=""  style="width:16px" title="向下追加" :ref="'add'+data.loopId" v-if="data.loopType=='OUT'" @click.stop="addLevel(data,node)"> -->
                                    <img src="@/assets/img/edit.png" alt=""  style="width:16px" title="编辑" v-if="!data.edit" @click.stop="editFun(data,node)">
                                    <img src="@/assets/img/save.png" alt="" style="width:16px" title="保存" ref="save" v-else @click.stop="saveGroup(data,node)">
                                    <i class="el-icon-circle-close" style="color:#0D94FF;font-size:20px;maring-left:5px" title="取消" @click.stop="cancelFun(node, data)" v-if="data.isadd"></i>
                                    <i class="el-icon-delete" style="color:#FD4238;font-size:18px" title="删除" @click.stop="deleteFun(data,node)" v-else></i>
                                </span>
                                <span v-else>
                                    <label v-if="(getLoopStatus(data)==1)||data.loopId==205||data.loopId==297||data.loopId==1566||data.loopId==1567" style="color:#FD4238">合闸</label>
                                    <label v-if="getLoopStatus(data)==0" style="color:#01AB65">分闸</label>
                                </span>
                            </div>
                            <!-- node.childNodes.length> -->
                            <div class="add" v-if="data.add===true&&editmode&&node.expanded" @click.stop="() => append(data,node)"><i class="el-icon-circle-plus-outline"></i>添加回路</div>
                        </div>
                    </el-tree>
                </div>
            </div>
            <div class="right">
                <Detail :currentLoop="currentLoop" @loopType="getloopType" :disabledIn="disabledIn" :looptypeShow="looptypeShow" :editmode="editmode" @upadteItemId="upadteItemId" :GTOShow="GTOShow"></Detail>
            </div>
        </div>
        <!-- <el-dialog
        class="dialogSwitch"
        title="您要删除的是？"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-radio-group v-model="checkradio" >
            <el-radio :label="0" size="medium">这条回路</el-radio>
            <el-radio :label="1" size="medium">这条回路和它下面的子回路</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
            <el-button class="cancel" @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary"  class="sub" @click="dialogVisible = false">确 定</el-button>
        </span>
        </el-dialog> -->
    </div>
</template>

<script>
import { deviceAll,loopList,loopTreeList ,delCascade,loopUpdate,loopAdd,updateSort} from "../../api/power";
import Detail from "./detail";
import { subscribe,subscribeByNodes } from '../../mqtt/index'
  export default {
    data() {
      return {
        editmode:false,
        list:[],
        keyword:"",
        currentLoop:{
            loopId:0
        },
        defaultProps: {
            children: 'childrenLoopList',
            label: 'loopName'
        },
        id: 0,
        checkradio:0,
        dialogVisible:false,
        draggable:false,
        looptype:"",  //回路类型
        disabledIn:false,
        looptypeShow:false,
        GTOShow:true,
      };
    },
    components:{
        Detail
    },
    computed:{
        homeitem(){
            return this.$store.state.homeitem.user
        },
        projectId(){
            return this.$store.getters.projectId
        },
        getLoopStatus(tpl) {
            return function (value) {
                subscribe([value.subLoopUrl]);
                return this.$store.getters.mqttVal(value.subLoopUrl + "/SwitchOn");
            };
        },
        result() {
            let onRecursionData = (arr, val) => {
                let newarr = []
                arr.forEach(item => {
                    if (item.childrenLoopList && item.childrenLoopList.length) {
                        let children = onRecursionData(item.childrenLoopList, val)
                        let obj = {
                            ...item,
                            children
                        }
                        if (children && children.length) {
                            newarr.push(obj)
                        }
                    } else {
                        if (item.loopName.includes(val)) {
                            newarr.push(item)
                        }
                    }
                })
                return newarr
            }
            let result = onRecursionData(this.list, this.keyword)
            return result
        }
    },
    watch:{
        keyword(val){
            this.$refs.tree.filter(val);
        },
        "currentLoop"(n,o){
            
        }
    },
    mounted(){
        this.getLoopList()
    },
    methods:{
        cancelFun(node, data){
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.childrenLoopList.findIndex(d => d.loopId === data.loopId);
            children.childrenLoopList.splice(index, 1);
            this.currentLoop = {}
        },
        insert(){
            const newChild = { loopId: "", loopName: '未命名回路',edit:true, childrenLoopList: [],isadd:true,isort:true };
            this.list.forEach(item1=>{
                item1.childrenLoopList.forEach(item2=>{
                    if(item2.loopType=='IN'){
                        item2.childrenLoopList.forEach((item3,index3)=>{
                            if(item3.loopId==this.currentLoop.loopId){
                                item2.childrenLoopList.splice(index3+1,0,newChild);
                            }
                        })
                    }else{
                        if(item2.childrenLoopList&&item2.childrenLoopList.length>0){
                            item2.childrenLoopList.forEach((item3,index3)=>{
                                item3.childrenLoopList.forEach((item4,index4)=>{
                                    if(item4.loopId==this.currentLoop.loopId){
                                        item3.childrenLoopList.splice(index4+1,0,newChild);
                                    }
                                })
                            })
                        }
                    }
                    
                })
            })  
            this.insertRecurrence(this.list,this.currentLoop.loopId)
        },
        insertRecurrence(list,id){  //递归
            list.forEach((item,index)=>{
                if(item.loopType!="IN"){
                    this.insertRecurrence(item.childrenLoopList)
                }else{
                    if(item.loopId==id){
                        item3.childrenLoopList.splice(index4+1,0,newChild);
                    }
                }
            })
        },
        addLevel(data,node){
            const newChild = { loopId: this.id++, loopName: '未命名回路'+this.id,edit:true, childrenLoopList: [],isadd:true };
            node.parent.childNodes.forEach((item,index)=>{
                if(item.data.loopId==data.loopId){
                    node.parent.childNodes.splice(index,0,newChild);
                }
            })
            
        },
        upadteItemId(loop){
            this.getLoopList(loop)
        },
        getloopType(name){
            this.looptype = name
        },
        addChildren(data,node){
            const newChild = { loopId: this.id++, loopName: '未命名回路'+this.id,edit:true, childrenLoopList: [],isadd:true };
            if (!data.childrenLoopList) {
                this.$set(data, 'childrenLoopList', []);
            }
            data.childrenLoopList.unshift(newChild);
            this.isEdit(this.list)
            this.currentLoop = newChild
        },
        handleClose(){
            this.dialogVisible = false
        },
        append(data,node) {
            const newChild = { loopId: this.id++, loopName: '未命名回路'+this.id,edit:true, childrenLoopList: [],isadd:true };
          
            if (!data.childrenLoopList) {
                this.$set(data, 'childrenLoopList', []);
            }
            data.childrenLoopList.unshift(newChild);
            if(node.level==1){
                this.looptypeShow = true
                if(node.childNodes.filter(e=>e.data.loopType=="GTI").length>0){
                    this.disabledIn = true
                }else{
                    this.disabledIn = false
                }
                if(node.childNodes.length>0&&node.childNodes.filter(e=>e.data.loopType=="IN").length>0){
                    this.GTOShow = false
                }else{
                    this.GTOShow = true
                }
            }else{
                this.looptypeShow = false
            }
            this.isEdit(this.list)
            this.currentLoop = newChild
        },
        //退出编辑
        exitFun(){
            this.editmode = false
            // this.isEdit(this.list)
            this.getLoopList()
        },
        //编辑
        editmodeFun(){
            this.editmode = true
            this.draggable = true
        },
        //保存
        async saveGroup(data,node){
            console.log(node,"node")
            if(data.isadd){  //新增
                let obj = {
                    projectId:this.$store.getters.projectId,
                    loopName:data.loopName,
                    pid:node.parent.data.pid,
                    highVoltageParentId:node.parent.data.loopId?node.parent.data.loopId:"",
                    isVirtual:0,
                    aid:node.parent.data.aid?node.parent.data.aid:node.parent.data.areaId,
                    loopType:this.looptype,
                    sort:node.parent.childNodes.length+1
                }
                
                if(this.looptype==""&&node.level==2){
                    this.$message.error('请选择回路类型！');
                    return flase
                }
                if(node.level==2){
                    obj.pid = 0
                }
                if(node.parent.data.loopType=='IN'){
                    obj.loopType = "OUT"
                    obj.highVoltageParentId = ""
                    obj.pid = node.parent.data.loopId
                }
                if(node.parent.data.loopType=='GTI'||node.parent.data.loopType=='GTO'){
                    obj.loopType = "IN"
                    obj.highVoltageParentId = node.parent.data.loopId
                    obj.pid = 0
                }
                let result = await loopAdd(obj);
                if(result.data.status){
                    data.edit = false
                    this.$message.success('新增成功！');
                    if(data.isort===true){
                        this.subaddSort(node,result.data.data.result)
                    }else{
                        this.getLoopList(result.data.data.result)
                    }
                }
            }else{  //更新
                let obj = {
                    loopName:data.loopName,
                    loopId:data.loopId
                }
                let result = await loopUpdate(obj);
                if(result.data.status){
                    data.edit = false
                    this.$message.success('修改成功！');
                }
            }


        },
        async subaddSort(node,loop){
            let list = node.parent.childNodes.map((e,i)=>{
                let l = {
                    loopId : e.data.loopId,
                    loopName:e.loopName,
                    sort:i+1
                }
                if(l.loopId==""){
                    l.loopId = loop.loopId
                }
                return l
            })
            let obj = JSON.stringify(list)
            let result = await updateSort(obj);
            this.getLoopList(loop)

        },
        editFun(data){
            this.expandedData(this.list)
            data.edit = !data.edit
            this.isEdit(this.list)
            this.currentLoop = data
        },
        expandedData(list,data) {
            list.forEach((item,index)=>{
                item.edit = false
                if(item.childrenLoopList&&item.childrenLoopList.length>0){
                    this.expandedData(item.childrenLoopList)
                }
            })
        },
        isEdit(list) {  //实时保存
            // list.forEach((item,index)=>{
            //     if(item.edit){
            //         this.$refs.save.dispatchEvent(new MouseEvent('click'));
            //     }
            //     if(item.childrenLoopList&&item.childrenLoopList.length>0){
            //         this.isEdit(item.childrenLoopList)
            //     }
            // })
        },
        //删除
        deleteFun(data,node){
            this.$confirm(data.loopName+" 这条回路", '您要删除的是？', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: '',
                customClass: "message_box"
            }).then(async () => {
                let obj = {
                    deviceLoopId:data.loopId
                }
                let result = await delCascade(obj);
                if(result.data.status){
                    this.$message.success('删除成功！');
                    this.getLoopList()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
            // this.dialogVisible = true
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.loopName.indexOf(value) !== -1;
        },
        handleNodeClick(data){
            if(!data.check){
                this.currentLoop = data;
            }
        },
        shrinkCheck(item){
            item.show=!item.show;
            this.$forceUpdate()
        },
        rebuildData(list) {
            list.forEach((item,index)=>{
                if(item.childrenLoopList&&item.childrenLoopList.length>0){
                    item.add = true
                    item.edit = false
                    this.rebuildData(item.childrenLoopList)
                }else{
                    item.edit = false
                }
            })
        },
        
        currLoop(list){
            list.forEach((item,index)=>{
                if(item.childrenLoopList&&item.childrenLoopList.length>0){
                    this.currentLoop = item.childrenLoopList[0]
                    return 
                }else{
                    this.currLoop(item.childrenLoopList)
                }
            })
            
        },
        async getLoopList(loop){
            // let result = await loopList({projectId:this.$store.getters.projectId});
            let result = await loopTreeList({projectId:this.$store.getters.projectId});
            let data = result.data.data
            let list = []
            data.forEach(item=>{
                item.loopName = item.areaName,
                item.add = true
                item.loopId = 0
                list.push(item)
            })
            
            // data.forEach(item=>{
            //     for(let key in item){
            //         let obj ={
            //             loopName:key,
            //             loopId:Math.random(),
            //             check:true,
            //             childrenLoopList:item[key]
            //         }
            //         list.push(obj)
            //     }
            // })
            this.rebuildData(list)
            this.list = list
            if(loop){
                this.currentLoop = loop
                setTimeout(() => {
                    const node = document.getElementById(loop.loopId)
                    if (node) {
                        node.scrollIntoView({ block: 'center' })
                    }
                }, 100)
                
            }else{
                this.currLoop(list)
                // if(list[0].childrenLoopList.length>0){
                //     this.currentLoop = list[0].childrenLoopList[0]
                // }else{
                //     this.currentLoop = {}
                // }
            }
        },
    }
  };
</script>

<style scoped lang="less">
/deep/.editmode{
    .el-tree-node__children{
        margin-top: 20px;
    }
}

.isadd ~ .el-tree-node__content{
    color:red
}
.dialogSwitch {
    /deep/.el-radio-group{
        .el-radio{
            margin: 20px 0px;
            display:block;
        }
        .el-radio__label{
            font-size:18px
        }
    }
}

/deep/ .mytree   {
    height: calc(100% - 10vh);
    // padding: 10px;
    padding-right: 20rem;
   overflow-y:auto;
   .handle{
    img{
        margin-right: 5rem;
    }
}
.el-input__inner{
    height: 32px !important;
}
   .el-tree{
    color: #333333;
   }
   .el-tree > .el-tree-node:after {
     border-top: none;
   }
   .el-tree-node {
     position: relative;
    //  padding-left: 12px;
     .el-tree-node__children{
        .el-tree-node__children{
            border:0
        }
        .el-tree-node__content{
            background: none;
            margin-bottom: 0px;
        }
     }
   }
   
   //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
   .el-tree-node__expand-icon.is-leaf {
     display: none;
   }
   .is-leaf+.custom-tree-node{
    font-weight: 400;
   }
   .el-tree-node__children {
     padding-left: 18px;
     border: 1px solid #F2F2F2;
     border-radius: 0px 0px 4px 4px;
   }

   .el-tree-node :last-child:before {
     height: 38px;
   }

   .el-tree > .el-tree-node:before {
     border-left: none;
   }

   .el-tree > .el-tree-node:after {
     border-top: none;
   }

   .el-tree-node:before {
     content: '';
     left: 0px;
     position: absolute;
     right: auto;
     border-width: 1px;
   }

   .el-tree-node:after {
     content: '';
     left: 0px;
     position: absolute;
     right: auto;
     border-width: 1px;
     border-top: 1px dashed #E5E5E5;
     height: 20px;
     top: 14px;
     width: 11px;
   }

   .el-tree-node:before {
     border-left: 1px dashed #E5E5E5;
     bottom: 0px;
     height: 100%;
     top: -26px;
     width: 1px;
   }
   .el-tree .el-tree-node__expand-icon.expanded {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    .el-tree .el-icon-caret-right:before {
      content: "+";
      border: 1px solid #666;
      border-radius: 2px;
      height: 14px;
      width: 14px;
      line-height: 14px;
      font-size:  16px;
      color:  #666;
      text-align: center;
      position:  absolute;
      left:  -20px;
      top:  -8px;
    }
    .el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before{
      content: "-";
      font-size : 18px;
      color:  #666;
      line-height: 12px;
      position:  absolute;
      left:  -20px;
      top : -8px;
   }
   .el-tree-node .el-tree-node__children .el-tree-node__children .el-tree-node__children{
    // padding-left: 18px !important;
    .el-tree-node__content{
        // padding-left: 0 !important;
    }
   }
   .el-tree-node__content{
        height: 32px;
        padding-left: 30px !important;
        background: #F2F2F2;
        border-radius: 4px;
        margin-bottom: 10px;
   }
   .el-tree-node__content>.el-tree-node__expand-icon {
     padding : 0;
   }
   .custom-tree-node{
		width: 100%;
        font-size: 14px;
        justify-content: space-between;
        padding-right: 10px;
        font-weight: 600;
        .land{
            width:100%;
            justify-content: space-between;
        }
        .name{
            display: inline-block;
            width:64%;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            vertical-align: middle;
        }
        .add{
            font-weight: 500;
            // display: none;
            position: absolute;
            top: 32px;
            i{
                color: #269A99;
                font-size: 18px;
                vertical-align: middle;
            }
        }
        label{
            font-weight: bold;
        }
   }

   
   .el-tree-node__children .el-tree-node.is-expanded{
        .add{
            display: block !important;
        }
    }


   .checked{
    color: #0D94FF;
   }
 }

.LoopMonitoring{
    background: #ffffff;
    height: 100%;
    width: 100%;
    
    .title{
        height: 50rem;
        line-height: 50rem;
        padding: 0 24px;
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }

    .content{
        height: calc(100% - 50rem);
        display: flex;
        padding:16px 0;
        width: 100%;
        box-sizing: border-box;

    }
    .left{
        .w(345);
        height: 100%;
        border-right: 1px solid rgba(51, 51, 51, 0.15);
        padding-left: 24rem;
        .all{
            font-size: 14px;
            line-height: 50px;
            .edit{
                float: right;
                width: 89px;
                height: 29px;
                line-height: 29px;
                text-align: center;
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                border-radius: 14px;
                color: #0D94FF;
                display: inline-block;
                margin-top: 10px;
                cursor: pointer;
            }
            .red{
                color: #FD4238;
            }
        }
    }
    .search{
        padding-right: 24rem;
    }
    .right{
        flex: 1;
        padding:0 24rem;
        position: relative;
    }
}

</style>